import { replaceDomainUrl } from "src/env";

interface IContentLink {
  href: string;
  target: string;
  children: React.ReactChild;
}

const ContentLink: React.FC<IContentLink> = (props) => {
  if (props.href) {
    return (
      <a target={props.target} href={replaceDomainUrl(props.href)}>
        {props.children}
      </a>
    );
  }

  return <>{props.children}</>;
};

export default ContentLink;
